import React from "react";
import { connect } from "react-redux";
import TextChart from "../../../Charts/TextChart";

const TextoChequesEnCartera = (props) => {
  const {
    monto,
    cantidadCheques,
    loading,
    error,
  } = props;

  return (
    <TextChart
      title={`Cheques en cartera`}
      bigAmount={monto}
      smallAmount={cantidadCheques}
      smallAmountTooltip={`Cant. cheques`}
      bigCurrency
      loading={loading}
      imgSinDatos={error}
      onBodyClick={() => props.onBodyClick()}
      cursorPointer
    />
  );
};

const mapStateToProps = (state) => {
  return {
    monto: state.ventas.chequesEnCartera.monto,
    cantidadCheques: state.ventas.chequesEnCartera.cantidadCheques,
    loading: state.ventas.chequesEnCartera.loading,
    error: state.ventas.chequesEnCartera.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoChequesEnCartera);
